import _toConsumableArray from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import React from "react";
var __jsx = React.createElement;
import { useState, useEffect, useRef } from "react";
import AwesomeIcon from "../../../components/AwesomeIcon";
import { faCalendar, faUser, faCircleCheck, faCircleExclamation, faClipboardList, faSpinner } from "@fortawesome/pro-regular-svg-icons";
import { truncate } from "lodash";
import { parse } from "best-effort-json-parser";
export default function PatientSummary(_ref) {
  var _patientData$current, _patientData$current2, _patientData$current3, _patientData$current4, _patientData$current5, _patientData$current6, _patientData$current7, _patientData$current8, _patientData$current9;
  var message = _ref.message;
  // const [patientData.current, setPatientData.current] = useState<PatientData.current | null>(null);
  var patientData = useRef({
    date: "",
    patient: {
      id: "",
      fullName: "",
      gender: "",
      age: 0,
      demographics: []
    },
    overview: "",
    timeline: []
  });
  useEffect(function () {
    if (message.length > 0) {
      var jsonMatchMarkdown = message.match(/```(?:json)?\s*([\s\S]*)/i);
      var messageData = message;
      if (jsonMatchMarkdown) {
        messageData = jsonMatchMarkdown[1];
      }
      var parsedMessageData = parse(messageData);
      patientData.current = parsedMessageData;
    }
  }, [message]);
  var _useState = useState(["timeline-20250408-0"]),
    openItems = _useState[0],
    setOpenItems = _useState[1];
  if (patientData.current === null) {
    return /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-center my-2 mx-4"
    }, /*#__PURE__*/React.createElement(AwesomeIcon, {
      name: faSpinner,
      size: "lg",
      className: "animate-spin"
    }), /*#__PURE__*/React.createElement("p", {
      className: "text-md italic pl-4"
    }, "Patient Summary is loading..."));
  }
  var formatDate = function formatDate(dateString) {
    try {
      var date = new Date(dateString);
      if (isNaN(date.getTime())) {
        return dateString; // Return original string if date is invalid
      }
      return date.toLocaleDateString("en-US", {
        month: "long",
        day: "numeric",
        year: "numeric"
      });
    } catch (error) {
      return dateString; // Return original string if parsing fails
    }
  };

  // Generate a unique ID for each timeline item
  var generateTimelineId = function generateTimelineId(date, index) {
    return "timeline-".concat(date === null || date === void 0 ? void 0 : date.replace(/-/g, ""), "-").concat(index);
  };
  var toggleItem = function toggleItem(value) {
    setOpenItems(openItems.includes(value) ? openItems.filter(function (item) {
      return item !== value;
    }) : [].concat(_toConsumableArray(openItems), [value]));
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "h-full bg-gray-950 border border-gray-800 rounded-lg  text-gray-200"
  }, /*#__PURE__*/React.createElement("div", {
    className: "max-w-2xl mx-auto"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bg-gray-900 shadow-md overflow-hidden border-0 rounded-lg"
  }, /*#__PURE__*/React.createElement("div", {
    className: "p-4 border-b border-gray-800 flex justify-between items-center bg-gray-800"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-3"
  }, /*#__PURE__*/React.createElement("h1", {
    className: "text-lg font-medium text-white"
  }, "Clinical Summary")), /*#__PURE__*/React.createElement("span", {
    className: "text-sm text-gray-300"
  }, formatDate((_patientData$current = patientData.current) === null || _patientData$current === void 0 ? void 0 : _patientData$current.date))), /*#__PURE__*/React.createElement("div", {
    className: "p-4 border-b border-gray-800 flex items-center gap-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "h-8 w-8 rounded-full bg-gray-800 flex items-center justify-center"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faUser,
    className: "h-5 w-5 text-[#FFA387]"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex-1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between items-start"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "text-lg font-medium text-white break-words"
  }, (_patientData$current2 = patientData.current) !== null && _patientData$current2 !== void 0 && (_patientData$current2 = _patientData$current2.patient) !== null && _patientData$current2 !== void 0 && _patientData$current2.fullName ? truncate((_patientData$current3 = patientData.current) === null || _patientData$current3 === void 0 || (_patientData$current3 = _patientData$current3.patient) === null || _patientData$current3 === void 0 ? void 0 : _patientData$current3.fullName, {
    length: 25
  }) : "Patient"), /*#__PURE__*/React.createElement("span", {
    className: "text-md text-gray-300 bg-gray-800 px-1.5 py-0.5 rounded"
  }, (_patientData$current4 = patientData.current) === null || _patientData$current4 === void 0 || (_patientData$current4 = _patientData$current4.patient) === null || _patientData$current4 === void 0 ? void 0 : _patientData$current4.age, "Y", " ", (_patientData$current5 = patientData.current) === null || _patientData$current5 === void 0 || (_patientData$current5 = _patientData$current5.patient) === null || _patientData$current5 === void 0 ? void 0 : _patientData$current5.gender)), /*#__PURE__*/React.createElement("p", {
    className: "text-sm text-gray-300 mt-1",
    dangerouslySetInnerHTML: {
      __html: (_patientData$current6 = patientData.current) === null || _patientData$current6 === void 0 || (_patientData$current6 = _patientData$current6.patient) === null || _patientData$current6 === void 0 || (_patientData$current6 = _patientData$current6.demographics) === null || _patientData$current6 === void 0 ? void 0 : _patientData$current6.join(" • ")
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "p-4 border-b border-gray-800"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-2 mb-3"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faCircleCheck,
    className: "h-5 w-5 text-teal-400"
  }), /*#__PURE__*/React.createElement("h2", {
    className: "text-lg font-medium text-teal-400"
  }, "Clinical Overview")), /*#__PURE__*/React.createElement("div", {
    className: "text-md text-gray-200 leading-relaxed",
    dangerouslySetInnerHTML: {
      __html: (_patientData$current7 = patientData.current) === null || _patientData$current7 === void 0 ? void 0 : _patientData$current7.overview
    }
  })), /*#__PURE__*/React.createElement(React.Fragment, null, ((_patientData$current8 = patientData.current) === null || _patientData$current8 === void 0 || (_patientData$current8 = _patientData$current8.timeline) === null || _patientData$current8 === void 0 ? void 0 : _patientData$current8.length) > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "px-4 py-3 border-b border-gray-800 flex items-center gap-2"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faCalendar,
    className: "h-5 w-5 text-teal-400"
  }), /*#__PURE__*/React.createElement("h2", {
    className: "text-lg font-medium text-teal-400"
  }, "Timeline of Events")), /*#__PURE__*/React.createElement("div", {
    className: "w-full"
  }, (_patientData$current9 = patientData.current) === null || _patientData$current9 === void 0 || (_patientData$current9 = _patientData$current9.timeline) === null || _patientData$current9 === void 0 ? void 0 : _patientData$current9.map(function (timelineItem, index) {
    var _timelineItem$events, _timelineItem$events2, _timelineItem$events3;
    var dateId = generateTimelineId(timelineItem.date, index);
    var formattedDate = formatDate(timelineItem.date);
    var isOpen = openItems.includes(dateId);
    return /*#__PURE__*/React.createElement("div", {
      key: dateId,
      className: "border-b border-gray-800"
    }, /*#__PURE__*/React.createElement("button", {
      className: "flex w-full items-center justify-between px-4 py-3 hover:bg-gray-800/50 text-white",
      onClick: function onClick() {
        return toggleItem(dateId);
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center gap-2"
    }, /*#__PURE__*/React.createElement("span", {
      className: "text-base font-medium"
    }, formattedDate), /*#__PURE__*/React.createElement("span", {
      className: "text-md ml-3 px-4 py-1 rounded-full bg-gray-800 text-gray-300"
    }, timelineItem === null || timelineItem === void 0 || (_timelineItem$events = timelineItem.events) === null || _timelineItem$events === void 0 ? void 0 : _timelineItem$events.length, " events")), /*#__PURE__*/React.createElement("svg", {
      className: "h-4 w-4 transition-transform ".concat(isOpen ? "rotate-180" : ""),
      fill: "none",
      viewBox: "0 0 24 24",
      stroke: "currentColor"
    }, /*#__PURE__*/React.createElement("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M19 9l-7 7-7-7"
    }))), /*#__PURE__*/React.createElement("div", {
      className: "overflow-hidden transition-all ".concat(isOpen ? "max-h-[1000px]" : "max-h-0")
    }, /*#__PURE__*/React.createElement("div", {
      className: "px-0 pb-0 pt-0"
    }, (timelineItem === null || timelineItem === void 0 || (_timelineItem$events2 = timelineItem.events) === null || _timelineItem$events2 === void 0 ? void 0 : _timelineItem$events2.length) > 0 && (timelineItem === null || timelineItem === void 0 || (_timelineItem$events3 = timelineItem.events) === null || _timelineItem$events3 === void 0 ? void 0 : _timelineItem$events3.map(function (event, eventIndex) {
      var _event$type, _timelineItem$events4, _event$items, _event$items2;
      // Determine icon and color based on event type
      var EventIcon = faClipboardList;
      var accentColor = "#5EEAD4"; // teal by default

      if (event !== null && event !== void 0 && (_event$type = event.type) !== null && _event$type !== void 0 && _event$type.includes("Imaging")) {
        EventIcon = faCircleExclamation;
        accentColor = "#FFA387"; // peach for imaging
      }
      return /*#__PURE__*/React.createElement("div", {
        key: "event-".concat(eventIndex),
        className: "px-4 py-3 ".concat(eventIndex < (timelineItem === null || timelineItem === void 0 || (_timelineItem$events4 = timelineItem.events) === null || _timelineItem$events4 === void 0 ? void 0 : _timelineItem$events4.length) - 1 ? "border-b border-gray-800/50" : "", " ").concat(eventIndex % 2 === 0 ? "bg-gray-800/20" : "bg-gray-800/10")
      }, /*#__PURE__*/React.createElement("div", {
        className: "flex items-start gap-3 mb-2"
      }, /*#__PURE__*/React.createElement(AwesomeIcon, {
        name: EventIcon,
        className: "h-5 w-5 mt-0.5 text-[#FFA387]"
      }), /*#__PURE__*/React.createElement("h3", {
        className: "text-normal font-medium text-white"
      }, event === null || event === void 0 ? void 0 : event.type)), /*#__PURE__*/React.createElement("ul", {
        className: "space-y-2 text-md pl-6"
      }, (event === null || event === void 0 || (_event$items = event.items) === null || _event$items === void 0 ? void 0 : _event$items.length) > 0 && (event === null || event === void 0 || (_event$items2 = event.items) === null || _event$items2 === void 0 ? void 0 : _event$items2.map(function (item, itemIndex) {
        return /*#__PURE__*/React.createElement("li", {
          key: "item-".concat(itemIndex),
          className: "text-gray-200 flex items-start "
        }, /*#__PURE__*/React.createElement("span", {
          className: "mr-2 mt-1 text-[#FFA387]"
        }, "\u2022"), /*#__PURE__*/React.createElement("span", null, item));
      }))));
    })))));
  })))), /*#__PURE__*/React.createElement("div", {
    className: "p-4 text-md text-gray-300 bg-gray-800/50 border-t border-gray-800"
  }, "Please refer to medical guidance for a comprehensive follow-up on AI interpretations and treatment contexts for this patient."))));
}